import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from '../../../core/services/alert-service.service';

import { MilestoneService } from '../../services/api/milestone.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.css'],
  standalone: true,
  imports: [TranslateModule],
})
export class AlertComponent implements OnInit, OnDestroy {
  private alertService = inject(AlertService);
  private milestoneService = inject(MilestoneService);
  private translate = inject(TranslateService);

  message: string | null = null;
  type: 'success' | 'error' | 'Note' | null = null;
  header: string = 'Note';
  okButton: boolean = false;
  notice: boolean = false;
  isConfirming: boolean = false;
  confirmCallback?: () => void | Promise<any>;
  confirmLabel: string = 'confirm';
  cancelCallback?: () => void;
  cancelLabel: string = 'cancel';
  hideButtons: boolean = false;
  private alertSubscription!: Subscription;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  ngOnInit() {
    this.alertSubscription = this.alertService.alert$.subscribe(alert => {
      this.message = alert.message;
      this.type = alert.type;
      if (this.type === 'Note' || this.type === 'error') {
        this.notice = true;
      }
      this.header = alert.header;
      this.confirmCallback = alert.confirmCallback;
      this.confirmLabel = alert.confirmLabel || this.translate.instant('confirm');
      this.cancelCallback = alert.cancelCallback;
      this.cancelLabel = alert.cancelLabel || this.translate.instant('cancel');

      if (this.confirmCallback && this.cancelCallback) {
        this.notice = false; // Show both buttons
      }
      // setTimeout(() => this.clearAlert(), 3000);
    });
  }

  ngOnDestroy() {
    if (this.alertSubscription) {
      this.alertSubscription.unsubscribe();
    }
  }

  clearAlert() {
    this.message = null;
    this.type = null;
    this.notice = false;
    this.isConfirming = false;
    this.hideButtons = false;
    this.confirmCallback = undefined;
    this.cancelCallback = undefined;
  }

  cancel() {
    if (this.cancelCallback) {
      this.cancelCallback();
    }
    this.clearAlert();
  }

  async confirm() {
    console.log('clicked confirm');
    if (this.confirmCallback) {
      const result = this.confirmCallback();
      if (result instanceof Promise) {
        this.isConfirming = true;
        try {
          const res = await result;
          if (res && res.successMessage) {
            this.message = res.successMessage;
            this.header = res.successHeader || 'Success';
            this.type = 'success';
            this.isConfirming = false;
            this.hideButtons = true;
            await new Promise(r => setTimeout(r, res.delay || 1500));
          }
        } catch (e) {
          console.error(e);
        } finally {
          this.isConfirming = false;
          this.hideButtons = false;
          this.clearAlert();
        }
        return;
      }
    }
    this.clearAlert();
  }
}
